/* eslint-disable @typescript-eslint/no-explicit-any */
import { Header } from '@/components/Layout/Header/Header';
import UploadQuizz from '@/components/Views/UploadQuizz/UploadQuizz';
import QuizzForm from './QuizzForm';
import { Button } from '@/components/Common';
import QuizzList from './QuizzList';
import { useQuizz } from './quizz.hook';
import { FadeLoader } from 'react-spinners';
import QuizzDeletionModal from './QuizzDeletionModal';

const Quizz = () => {
  const { quizzList, openQuizModal, loadingQuizz } = useQuizz();

  return (
    <div className="flex flex-col max-h-screen">
      <UploadQuizz type="quizz" />
      <QuizzDeletionModal />
      <Header goBack title="QUIZ" userName="Mas Aly" role="Admin" />
      <div className="grid grid-cols-[33%_auto] items-start">
        <div className="px-9 pb-6 flex flex-col gap-5 pt-2 h-[calc(100vh_-_110px)] overflow-y-auto scrollbar-hide">
          <h3 className="text-white text-[27.99px] font-bold  text-left">
            Ajouter question
          </h3>
          <QuizzForm />
        </div>
        <div className="flex flex-col gap-2 pl-10 pr-5 pt-2 h-[calc(100vh_-_110px)] overflow-y-auto scrollbar-hide">
          {loadingQuizz ? (
            <div className="w-full h-[100vh] flex items-center justify-center">
              <FadeLoader color="#FEC200" />
            </div>
          ) : (
            <>
              <div className="flex justify-between items-center">
                {quizzList && (
                  <h3 className="text-white text-[27.99px] font-bold  text-left">
                    {quizzList[0]?.lesson?.name}
                    <span className="text-[#616163] text-base font-light block">
                      {quizzList.length} Questions
                    </span>
                  </h3>
                )}

                <Button
                  title="Upload"
                  icon={<i className="pi pi-upload"></i>}
                  iconPosition="right"
                  className="!px-12"
                  onClick={openQuizModal}
                />
              </div>
              <QuizzList />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Quizz;
